// Generated by tools/pack-atlas.py. Do not edit.
/** Per sheet, per sprite index: [x, y, w, h] in the packed sheet, then [x, y] of that box relative to
 *  the sprite's original 256px cell, so sprites keep their authored placement. */
export const ATLAS_FRAMES: Record<string, ([number, number, number, number, number, number] | null)[]> = {"south/airport-people.png":[[4,4,165,225,56,24],
    [256,4,153,230,54,20],
    [508,4,160,225,53,25],
    [760,4,161,225,56,26],
    [4,256,157,234,60,12],
    [256,256,166,231,54,16],
    [508,256,159,238,49,10],
    [760,256,161,231,53,17],
    [4,508,159,230,54,4],
    [256,508,165,226,57,8],
    [508,508,164,229,52,5],
    [760,508,170,227,54,10],
    [4,760,134,242,71,-15],
    [256,760,135,241,74,-14],
    [508,760,138,244,66,-16],
    [760,760,132,240,75,-11]],"east/airport-people.png":[[4,4,173,230,60,35],
    [249,4,142,237,67,28],
    [494,4,153,229,62,37],
    [739,4,147,233,68,34],
    [4,249,169,235,63,30],
    [249,249,157,236,62,27],
    [494,249,148,226,65,37],
    [739,249,153,230,65,35],
    [4,494,152,236,58,18],
    [249,494,151,231,63,22],
    [494,494,173,234,64,19],
    [739,494,153,223,71,31],
    [4,739,124,227,80,6],
    [249,739,132,227,79,6],
    [494,739,134,225,73,8],
    [739,739,125,229,93,4]],"north/airport-people.png":[[4,4,163,229,64,35],
    [253,4,157,230,71,34],
    [502,4,163,227,61,38],
    [751,4,163,233,62,31],
    [4,253,166,241,66,22],
    [253,253,166,239,66,24],
    [502,253,164,234,67,29],
    [751,253,167,233,62,30],
    [4,502,168,232,64,20],
    [253,502,172,225,59,26],
    [502,502,168,233,65,19],
    [751,502,183,223,50,29],
    [4,751,148,235,62,0],
    [253,751,146,233,67,2],
    [502,751,147,229,64,6],
    [751,751,147,237,63,-2]],"west/airport-people.png":[[4,4,155,229,23,7],
    [255,4,159,221,11,17],
    [506,4,160,235,8,4],
    [757,4,162,231,22,9],
    [4,255,159,230,17,3],
    [255,255,161,232,18,1],
    [506,255,159,223,12,13],
    [757,255,159,230,27,3],
    [4,506,161,232,17,-5],
    [255,506,168,225,18,0],
    [506,506,164,233,13,-5],
    [757,506,178,220,26,6],
    [4,757,142,243,25,-20],
    [255,757,143,237,31,-14],
    [506,757,145,222,27,1],
    [757,757,144,241,38,-16]]};
